import { render, staticRenderFns } from "./OptionsEdit.vue?vue&type=template&id=dab04e16&scoped=true&"
import script from "./OptionsEdit.vue?vue&type=script&lang=js&"
export * from "./OptionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./OptionsEdit.vue?vue&type=style&index=0&id=dab04e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab04e16",
  null
  
)

export default component.exports